import React, { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { CustomerCardType } from '@models/commerce/CustomerCardType'

interface Props {
  card: CustomerCardType
}
const CustomerCard: FC<Props> = ({ card }) => {
  const { t } = useTranslation()
  return (
    <p className="text-md" data-testid="saved-card-item">
      {card.brand} {t('content.endingIn')} <span className="font-semibold">{card.last4}</span>{' '}
      <span className="mx-2">{card.address.name}</span>
      Exp{' '}
      <span className="font-semibold">
        {card.exp_month}/{String(card.exp_year).slice(-2)}
      </span>
    </p>
  )
}

export default CustomerCard
